import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {RacunDocument} from "./RacunDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor, datum valute, iznos
// opciono: opis, lista priloga, tekući račun

export const racunDocumentFields: IntercateKeysMap<RacunDocument, EntityField<RacunDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	dueDate: {
		name: "dueDate", dataType: EntityFieldDataType._date, label: "Datum valute",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	amount: {
		name: "amount", dataType: EntityFieldDataType._number, label: "Iznos",
		validator: { required: true },
		sortable: true
	},
	accountNumber: {
		name: "accountNumber", dataType: EntityFieldDataType._string, label: "Broj tekućeg računa",
		validator: { required: false },
		sortable: true
	},
	selectedForPayment: {
		name: "selectedForPayment", dataType: EntityFieldDataType._boolean, label: "Selektovan za plaćanje",
		validator: { required: false },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<RacunDocument>> = [
	racunDocumentFields.indexingNumber,
	racunDocumentFields.indexingDate,
	racunDocumentFields.documentNumber,
	racunDocumentFields.documentDate,
	racunDocumentFields.assignedTo,
	racunDocumentFields.clientId,
	racunDocumentFields.sectorId,
	racunDocumentFields.tags,
	racunDocumentFields.description,
	racunDocumentFields.dueDate,
	racunDocumentFields.amount,
	racunDocumentFields.accountNumber,
	racunDocumentFields.selectedForPayment,
	racunDocumentFields.parentId
]

export const racunDocumentFieldsDescriptor: EntityFieldsDescriptor<RacunDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
